import {
  NEW_PROJECT,
  EDIT_PROJECT,
  NEXT_STAGE,
  NEW_PROJECT_FORM_VALUE_CHANGE,
  NEW_PROJECT_GC_SET,
  NEW_PROJECT_CURRENT_PAGE_SET,
  NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE,
  NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE,
  NEW_PROJECT_NEW_CLIENT_MODAL_SHOW,
  NEW_PROJECT_NEW_CLIENT_FORM_CLEAN,
  NEW_PROJECT_NEW_BUILDING_MODAL_SHOW,
  NEW_PROJECT_NEW_BUILDING_FORM_CLEAN,
  NEW_PROJECT_ID_SET,
  EDIT_PROJECT_FORM_SET_VALUES,
} from 'components/admin/projects/creation/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { projectsApi } from 'services/api/projects-api';
import { generalContractorsApi } from 'services/api/general-contractors-api';
import { clientsApi } from 'services/api/clients-api';
import { buildingsApi } from 'services/api/buildings-api';

export function newProject() {
  return {
    type: NEW_PROJECT,
  };
}

export function editProject() {
  return {
    type: EDIT_PROJECT,
  };
}

export function nextStage() {
  return {
    type: NEXT_STAGE,
  };
}

export function setProjectFormValue(attribute, value) {
  return {
    type: NEW_PROJECT_FORM_VALUE_CHANGE,
    payload: { attribute, value },
  };
}

export function setProjectFormValues(project) {
  return {
    type: EDIT_PROJECT_FORM_SET_VALUES,
    payload: project,
  };
}

export function setNewProjectId(newProjectId) {
  return {
    type: NEW_PROJECT_ID_SET,
    payload: newProjectId,
  };
}

export function createProject(values) {
  return (dispatch) => {
    return projectsApi.createProject(values).then((response) => {
      if (response.ok) {
        dispatch(setNewProjectId(response.project.id));
        dispatch(nextStage());
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function updateProject(id, values) {
  return (dispatch) => {
    return projectsApi.updateProject(id, values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function setGeneralContractors(generalContractors) {
  return {
    type: NEW_PROJECT_GC_SET,
    payload: generalContractors,
  };
}

export function changePage(page) {
  return {
    type: NEW_PROJECT_CURRENT_PAGE_SET,
    payload: page,
  };
}

export function loadGeneralContractorsRequest(page) {
  return (dispatch) => {
    return generalContractorsApi
      .getGeneralContractors(page)
      .then((response) => {
        if (response.ok) {
          dispatch(setGeneralContractors(response.generalContractors));
          dispatch(changePage(page));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setClientFormValue(attribute, value) {
  return {
    type: NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE,
    payload: { attribute, value },
  };
}

export function setShowNewClientModal(value) {
  return {
    type: NEW_PROJECT_NEW_CLIENT_MODAL_SHOW,
    payload: value,
  };
}

export function cleanClientFormValues() {
  return {
    type: NEW_PROJECT_NEW_CLIENT_FORM_CLEAN,
  };
}

export function findSimilarClient(values) {
  return (dispatch) => {
    return clientsApi.findSimilar(values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function createClient(values) {
  return (dispatch) => {
    return clientsApi.inviteClient(values, true).then((response) => {
      if (response.ok) {
        dispatch(setProjectFormValue('clientId', response.client.id));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function inviteExistentClient(clientId) {
  return (dispatch) => {
    return clientsApi.inviteExistent(clientId).then((response) => {
      if (response.ok) {
        dispatch(setProjectFormValue('clientId', clientId));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function setBuildingFormValue(attribute, value) {
  return {
    type: NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE,
    payload: { attribute, value },
  };
}

export function cleanBuildingFormValues() {
  return {
    type: NEW_PROJECT_NEW_BUILDING_FORM_CLEAN,
  };
}

export function setShowNewBuildingModal(value) {
  return {
    type: NEW_PROJECT_NEW_BUILDING_MODAL_SHOW,
    payload: value,
  };
}

export function createBuilding(values) {
  return (dispatch) => {
    return buildingsApi.createBuilding(values).then((response) => {
      if (response.ok) {
        dispatch(setProjectFormValue('buildingId', response.building.id));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/store/actions.js